export const buildValueMap = (enumDef) => {
    const map = {};
    Object.entries(enumDef).forEach(([key, item]) => {
        map[key] = item.value;
    });
    return map;
};

export const buildEnumOptions = (enumDef) => {
    return Object.entries(enumDef).map(([, item]) => ({
        ...item
    }));
};
